<!--  -->
<template>
  <div class="">
    <common-title
      titleName="学习报告"
      :bcColor="'#F9F9F9'"
      :isAPPShow="true"
      :zIndex="1000"
      v-if="!isMiniProgram"
    >
    </common-title>
    <template v-if="!isEmpty">
      <section :class="isMiniProgram ? 'section miniprogram' : 'section'">
        <section class="head-top">
          <div class="head-img">
            <img :src="userInfo.avatar || require('../../../assets/img/personalImg/defaultAvatar.png')" />
            <div>
              <span>亲爱的 {{ userInfo.nickName || userInfo.userName }}</span>
              <p>你的努力，启航为你记录</p>
            </div>
          </div>
          <div class="head-time">最近学习时间：{{ studyInfo.lastLearnTime || '--' }}</div>
        </section>

        <StudyProgress :studyInfo="studyInfo" />
        <StudyColumn
          v-if="weekTimeList"
          :weekTimeList="weekTimeList"
        />
        <StudyExam
          v-if="showExam"
          :studyExamList="studyExamList"
        />

      </section>
      <div class="share-btn-Box">
        <button
          class="share-btn"
          @click="toShare"
        >分享</button>
      </div>

      <ShareReport
        v-if="showShare"
        :studyInfo="studyInfo"
        :showWeekInfo="showWeekInfo"
      />
    </template>
    <EmptyData
      v-else
      :emptyName="'noReport'"
    />
    <CommonLoading v-if="loading" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  reqStudyReport, reqStudyBasisInfo, reqStudyExamInfo, reqStudyServiceInfo, reqStudyWeekTime,
} from '@/api/learningGuidePage';
import EmptyData from '@/components/emptyData/emptyData.vue';
import { replaceHyphens, whatEev } from '@/utils/tools';
import CommonLoading from '@/components/commonComponents/CommonLoading.vue';
import ShareReport from './shareReport.vue';
import StudyProgress from './studyProgress.vue';
import StudyColumn from './studyColumn.vue';
import StudyExam from './studyExam.vue';

export default {
  components: {
    ShareReport,
    StudyProgress,
    EmptyData,
    StudyColumn,
    StudyExam,
    CommonLoading,
  },
  data() {
    return {
      showShare: false,
      studyInfo: {},
      showWeekInfo: true,
      isEmpty: false,
      studyExamList: null,
      weekTimeList: null,
      showExam: false,
      loading: true,
      isMiniProgram: false,
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
  methods: {
    toShare() {
      if (this.loading) return;
      this.showShare = true;
    },
    async getStudyBasisInfo() {
      const { userProductId } = this.$route.query;
      // 查询用户学习报告基础信息;
      const p1 = reqStudyBasisInfo(userProductId);
      // 查询用户学习报告服务信息
      const p2 = reqStudyServiceInfo(userProductId);
      // 查询用户学习报告考试信息
      const p3 = reqStudyExamInfo(userProductId, 1, 10);
      // 查询用户学习报告周学习时长信息
      const p4 = reqStudyWeekTime(userProductId);

      Promise.all([p1, p2, p3, p4]).then((result) => {
        const res = result[0];
        const res1 = result[1];
        const res2 = result[2];
        const res3 = result[3];
        this.loading = false;
        if (!res.data && !res1.data && !res2.data && !res3.data) {
          this.isEmpty = true;
          return;
        }
        this.studyInfo = {
          ...res1?.data,
          ...res2?.data,
          ...res?.data,
        };
        this.studyExamList = res2?.data?.examInfoVOS;
        this.showExam = res2?.data?.examInfoVOS?.total > 0;

        this.weekTimeList = res3?.data?.length > 0 ? res3?.data : null;
        if (
          // 学习时间都为0 不展示
          this.weekTimeList?.every((item) => item.dayLearnDuration === 0)
        ) {
          this.weekTimeList = null;
        } else {
          // eslint-disable-next-line no-unused-expressions
          this.weekTimeList?.map((item) => {
            Object.assign(item, {
              statisticsDate: replaceHyphens(item.statisticsDate).slice(5),
              dayLearnDuration: Math.ceil(item.dayLearnDuration / 60),
            });
          });
        }
      });
    },
    // async getReport() {
    //   const { userProductId } = this.$route.query;
    //   const { code, data } = await reqStudyReport(userProductId);
    //   if (code === 0 && data) {
    //     this.isEmpty = false;
    //     const { userLearnReportRespVO, userLearnReportDetailRespVO } = data;
    //     const {
    //       learnEndTime,
    //       learnStartTime,
    //       upFromLastWeek,
    //       weekLearnDuration,
    //     } = userLearnReportDetailRespVO;
    //     this.studyInfo = { ...userLearnReportRespVO, ...userLearnReportDetailRespVO };
    //     this.showWeekInfo = !(
    //       learnEndTime === null
    //       && learnStartTime === null
    //       && upFromLastWeek === null
    //       && weekLearnDuration === null
    //     );
    //   } else {
    //     this.isEmpty = true;
    //   }
    // },
    change() {
      const docEl = document.documentElement;
      if (docEl.clientWidth > 470) {
        setTimeout(() => {
          docEl.style.fontSize = '40px';
        }, 300);
      }
    },
  },
  created() {
    if (whatEev() === 'miniprogram') {
      this.isMiniProgram = true;
      document.title = '学习报告';
    }
    this.change();
    window.onresize = () => {
      this.change();
    };
  },
  mounted() {
    this.getStudyBasisInfo();
  },
};
</script>
<style lang="scss" scoped>
.section {
  padding: 100px 0 30px 0;
}
.miniprogram {
  padding-top: 0;
}

.head-top {
  width: 750px;
  height: 438px;
  margin: 0 auto;
  padding: 58px 36px 0 36px;
  background-color: #ff6b00;
  background-image: url('../../../assets/img/learningGuidePage/report-head.png');
  background-repeat: no-repeat;
  background-size: 100%;
  .head-img {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    > img {
      width: 109px;
      height: 109px;
      margin-right: 22px;
      border: 5px solid #fff;
      border-radius: 50%;
    }
    > div {
      span {
        display: inline-block;
        width: 350px;
        overflow: hidden;
        color: #fff;
        font-weight: 500;
        font-size: 29px;
        line-height: 40px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      p {
        color: #fff;
        font-weight: 500;
        font-size: 25px;
        line-height: 36px;
      }
    }
  }
  .head-time {
    padding: 36px 0 33px 0;
    color: #fff;
    font-weight: 400;
    font-size: 25px;
    line-height: 36px;
  }
}
.study-progress {
  position: relative;
  top: -150px;
  z-index: 1;
}
.study-week {
  position: relative;
  top: -130px;
  z-index: 1;
}
.columnBox {
  position: relative;
  top: -130px;
}
.examList {
  position: relative;
  top: -110px;
}
.share-btn-Box {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: center;
  background: #fff;
  .share-btn {
    // z-index: 20;
    width: 678px;
    // position: fixed;
    // bottom: 20px;
    // left: 36px;
    // right: 36px;
    margin: 0 auto 36px auto;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    line-height: 80px;
    background: #ff7f41;
    border-radius: 45px;
  }
}

.emptyIndent {
  padding-top: 200px;
}
</style>
